module.exports = __webpack_public_path__ + "img/guac-logo.8aa25deb.png";